import { css, jsx } from '@emotion/core';
import { halfSpacing, quarterSpacing } from 'styles/global_defaults/scaffolding';

export enum PlaceholderType {
  LINE = 'line',
  AVATAR = 'avatar',
  PANEL = 'panel',
}

export enum Shape {
  ROUND = 'round',
  SQUARE = 'square',
}

interface BaseProps {
  type: PlaceholderType,
  width?: string,
}

export enum AvatarSize {
  EXTRA_SMALL = '20px',
  SMALL = '30px',
  MEDIUM = '40px',
  LARGE = '60px',
  EXTRA_LARGE = '100px',
}

export enum LineSize {
  SHORT = 'short',
  FULL = 'full',
  MEDIUM = 'medium',
}

export enum LineHeight {
  HALF_SPACING = halfSpacing,
  QUARTER_SPACING = quarterSpacing,
}


const mapLineSize: {[Key in LineSize]: string} = {
  [LineSize.FULL]: '100%',
  [LineSize.SHORT]: '50%',
  [LineSize.MEDIUM]: '60%',
};

interface AvatarPlaceHolderProps extends BaseProps {
  size: AvatarSize,
  className?: string,
  shape?: Shape,
  height?: LineHeight
}

interface LinePlaceHolderProps extends BaseProps {
  size: LineSize,
  className?: string,
  shape?: Shape,
  height?: LineHeight,
}
interface PanelPlaceholderProps {
  width: string,
  height: string,
}

type NvLoadingPlaceholderProps = LinePlaceHolderProps | AvatarPlaceHolderProps ;

const NvLoadingPlaceholder = (props: NvLoadingPlaceholderProps) => {
  const { size, type, shape, height, className = '' } = props;

  let styles = type === PlaceholderType.AVATAR ? css`
      width: ${size};
      height: ${size};
      margin: auto;
      border-radius: ${shape === Shape.ROUND ? '50%' : '5%'};
    ` : '';
  styles = type === PlaceholderType.LINE ? css`
      width: ${mapLineSize[size]};
      height: ${height ?? halfSpacing}px;
    ` : '';
  styles = type === PlaceholderType.PANEL ? css`
      width: ${size};
      height: ${size};
    ` : '';
  return <div css={styles} className={`loading ${type} gray-2 m-1 ${className}`} aria-hidden='true' />;
};


export const NVLoadingPlaceholderPanel = (props: PanelPlaceholderProps) => {
  const { width, height } = props;
  const styles = css`
  width: ${width};
  height: ${height};
  margin: auto;`;
  return <div css={styles} className='loading panel gray-2 m-1' aria-hidden='true' />;
};

export default NvLoadingPlaceholder;
